import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';
import FilterContainer from './FilterContainer';
import DatePicker from 'react-datepicker';
import useDataContext from '../../context/useDataContext';
import useCore from '../../methods/core/useCore';

function FilterDate(props) {
  const {
    taxonomy,
    taxSlug,
    label,
    scrollable,
    collapsible
  } = props;
  
  const {filterReset, setFilterReset} = useDataContext();
  const {replaceSelected} = useCore();
  const [today] = useState(new Date());
  const [startDate, setStartDate] = useState(new Date());
  const filterId = 'filter-date';

  FilterDate.propTypes = {
    taxonomy: PropTypes.array,
    taxSlug: PropTypes.string,
    label: PropTypes.string,
    scrollable: PropTypes.bool,
    collapsible: PropTypes.bool
  }

  function changeHandler(date) {
    let dateFound = false;
    let formattedDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];
    formattedDate = formattedDate.replaceAll('-', '');
    setStartDate(date);

    taxonomy.forEach(term => {
      if (term.slug === formattedDate) {
        replaceSelected(term.id, taxSlug);
        dateFound = true;
      }
    });

    if (!dateFound) {
      replaceSelected(undefined, taxSlug);
    }
  }

  function resetDate() {
    if (filterReset) {
      setStartDate(today);
      setFilterReset(false);
    }
  }

  useEffect(() => {
    resetDate();
  }, [filterReset]);

  return(
    <FilterContainer 
      filterId={filterId}
      className="filter-date"
      label={label}
      collapsible={collapsible}
      scrollable={scrollable}
    >
      <DatePicker
        id={`${filterId}-input`}
        selected={startDate}
        onChange={(date) => {changeHandler(date)}}
      ></DatePicker>
    </FilterContainer>
  )
}

export default FilterDate;